import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import Box from "@mui/material/Box";
import { CsAttributeController } from "@plansoft-configuration-renderer/framework";
import { ControlLayoutContext } from "@plansoft-configuration-renderer/layout";
import { SubstructureContent } from "../../Controls/Substructure/SubstructureContent";
import { SubstructureVariant, } from "../../Controls/Substructure/SubstructureLayout";
import { useConfigurationObjectScrolling } from "../../NavigationState";
// FIXME Using this as default might be a problem
const DEFAULT_LAYOUT_PROPS = {
    variant: SubstructureVariant.Embedded,
    defaultExpanded: true,
};
/**
 * Tab item for subconfiguration instances
 *
 * This replicates some parts of the layout mechanism to display a single subconfiguration instance
 *
 * @category UI
 * @param props
 * @returns
 */
export function SubconfigurationInstance(props) {
    var _a, _b;
    const { attribute, instancePath } = props;
    const { FallbackUi, LoadingIndicator } = (_a = props.components) !== null && _a !== void 0 ? _a : {};
    // find the subconfiguration instance that matches the path
    const substructure = ((_b = attribute.configurations) !== null && _b !== void 0 ? _b : []).find((item) => item.path === instancePath);
    if (!substructure) {
        throw new Error(`SubconfigurationInstance not found: ${instancePath}`);
    }
    const elementRef = useConfigurationObjectScrolling({
        configurationObject: substructure,
    });
    return (_jsx(Fragment, { children: _jsx(CsAttributeController, { attribute: attribute, children: _jsx(ControlLayoutContext.Provider, { value: DEFAULT_LAYOUT_PROPS, children: _jsx(Box, { ref: elementRef, children: _jsx(SubstructureContent, { substructure: substructure, FallbackUi: FallbackUi, LoadingIndicator: LoadingIndicator }) }) }) }) }));
}
//# sourceMappingURL=SubconfigurationInstance.js.map